
export class State {
  group: boolean;
  validRequest: boolean;
  reqType: string;

  constructor(group: boolean, validRequest: boolean, reqType: string) {
    this.group = group;
    this.validRequest = validRequest;
    this.reqType = reqType;
  }
}
